import type { BuildSources } from "@brickme/project-core/src/image-build/create-bricked-image-from-source.ts";
import { isOnceOffLoaded } from "~/utils/loading.ts";
import type { CreatorProject } from "./state.ts";

function creatorProjectToBuildSources(project: CreatorProject): BuildSources {
	return {
		original: project.sourceImage.bitmap,
		backgroundMask: isOnceOffLoaded(project.backgroundMask)
			? project.backgroundMask.data
			: undefined,
		enhanceFaces: isOnceOffLoaded(project.enhanceFacesImage)
			? project.enhanceFacesImage.data
			: undefined,
		posterise: isOnceOffLoaded(project.posteriseImage)
			? project.posteriseImage.data
			: undefined,
		colorisation: isOnceOffLoaded(project.colorisationImage)
			? project.colorisationImage.data
			: undefined,
		facesMask: project.facesMask,
	};
}

export default creatorProjectToBuildSources;
